import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { hotelPath } from 'app/hooks/data/hotels/useHotel';
import type { AutoInventoryForm } from 'app/typings/core/extranet/inventory/form/autoInventoryForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS as HOTEL_QUERY_KEYS } from '../../hotel/index';

import { CORE_QUERY_KEYS, ENDPOINTS } from '..';

export function useSaveAutoInventory(
  hotelId: number,
  options: { startDate: string; endDate: string }
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: AutoInventoryForm) =>
      apiMutation(
        'POST',
        {
          path: ENDPOINTS.saveAutoInventory,
          params: { hotelId: hotelId.toString() },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      message.success('Auto inventory successfully saved');

      queryClient.invalidateQueries({ queryKey: [hotelPath, { hotelId }] });
      queryClient.invalidateQueries({
        queryKey: [HOTEL_QUERY_KEYS.hotelInfo, { id: hotelId }],
      });

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.inventory, { hotelId: hotelId, ...options }],
      });
      queryClient.invalidateQueries({
        queryKey: [HOTEL_QUERY_KEYS.hotelRooms, { id: hotelId }],
      });
    },
    onError: () => {
      message.error('Failed to save auto inventory.');
    },
  });
}
